module.exports = __webpack_public_path__ + "634b76f1599c1b6ea2f1446b36e47fe3.MP3";